module.exports = __webpack_public_path__ + "img/title-bg.a42a3fb8.png";